import * as React from 'react'

import classes from './CheckList.module.scss'
import tick from '../../assets/images/general-icons/icon-checkmark.svg'

type ElementProps = React.HTMLAttributes<HTMLUListElement>
type ItemProps = React.LiHTMLAttributes<HTMLLIElement>
type TickImageProps = React.ImgHTMLAttributes<HTMLImageElement>

export const ListElement = ({ className, ...props }: ElementProps) => (
  <ul
    className={[classes.listElement, className].filter(Boolean).join(' ')}
    {...props}
  />
)

export const ListItem = ({ className, ...props }: ItemProps) => (
  <li
    className={[classes.listItem, className].filter(Boolean).join(' ')}
    {...props}
  />
)

export const TickImage = ({
  className,
  src,
  alt = '',
  ...props
}: TickImageProps) => (
  <img
    src={src || tick}
    alt={alt}
    className={[classes.tickImage, className].filter(Boolean).join(' ')}
    {...props}
  />
)
